import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const NEW = "__new__";

export const CategoryPicker = ({ value, onChange, categories, testid = "category-picker" }) => {
  const [custom, setCustom] = useState(false);
  if (custom) {
    return (
      <div className="flex gap-2">
        <Input autoFocus placeholder="Nome da nova categoria" value={value} maxLength={40}
          onChange={(e) => onChange(e.target.value)} data-testid={`${testid}-new-input`} />
        <button type="button" onClick={() => { setCustom(false); onChange("Outros"); }}
          className="text-xs text-slate-500 hover:text-rose-600 whitespace-nowrap" data-testid={`${testid}-cancel-new`}>Usar lista</button>
      </div>
    );
  }
  return (
    <Select value={value || "Outros"} onValueChange={(v) => { if (v === NEW) { setCustom(true); onChange(""); } else onChange(v); }}>
      <SelectTrigger data-testid={testid}><SelectValue /></SelectTrigger>
      <SelectContent>
        {categories.map(c => <SelectItem key={c} value={c}>{c}</SelectItem>)}
        <SelectItem value={NEW} data-testid={`${testid}-new-option`}>+ Nova categoria…</SelectItem>
      </SelectContent>
    </Select>
  );
};
